import {StatusMessagesState} from './states/status-messages.state';
import {LimitMessagesState} from './states/limit-messages.state';

export const eventMessagesState = [
    StatusMessagesState,
    LimitMessagesState
];
